module.exports = __webpack_public_path__ + "static/3-172531492804d5aed3e9f4448d6cb729.png";